import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type CallbackEventParams = {
	eventName: string;
	componentName?: string;
};
export class CallbackEvent extends BaseEvent {
	constructor({ eventName, componentName = '' }: CallbackEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Callback,
				eventName,
			},
			attributes: {
				componentName,
			},
		});
	}
}
